import routes from "./routes.json";
import { FAQS } from "../data/content";

const SITE = "https://www.thekrstudio.com";
const ORG_ID = `${SITE}/#organization`;
const WEBSITE_ID = `${SITE}/#website`;

const desc = (p) => routes.find((r) => r.path === p)?.description;

const FOUNDERS = [
  { "@type": "Person", "@id": `${SITE}/about#roohi-maryam`, name: "Roohi Maryam" },
  { "@type": "Person", "@id": `${SITE}/about#kafeel-rabbani`, name: "Kafeel Rabbani" },
];

const organization = {
  "@type": ["Organization", "ProfessionalService"],
  "@id": ORG_ID,
  name: "KR Studio",
  url: `${SITE}/`,
  logo: `${SITE}/icon-512.png`,
  image: `${SITE}/assets/og-image.jpg`,
  description: desc("/"),
  email: "ask.kr.studio@gmail.com",
  telephone: "+91-70066-76788",
  areaServed: ["IN", "Worldwide"],
  address: { "@type": "PostalAddress", addressRegion: "Delhi NCR", addressCountry: "IN" },
  founder: FOUNDERS,
  sameAs: [
    "https://www.instagram.com/the.krstudio/",
    "https://www.linkedin.com/company/kr-studio-india/",
  ],
  knowsAbout: [
    "Branding",
    "Brand identity",
    "Brand strategy",
    "Social media marketing",
    "Performance marketing",
    "Website design",
    "Video production",
    "Motion graphics",
    "AI video production",
    "AI creative production",
  ],
};

const website = {
  "@type": "WebSite",
  "@id": WEBSITE_ID,
  url: `${SITE}/`,
  name: "KR Studio",
  publisher: { "@id": ORG_ID },
  inLanguage: "en-IN",
};

const faqPage = {
  "@type": "FAQPage",
  "@id": `${SITE}/#faq`,
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

const webPage = (path, name) => ({
  "@type": "WebPage",
  "@id": `${SITE}${path}`,
  url: `${SITE}${path}`,
  name,
  description: desc(path),
  isPartOf: { "@id": WEBSITE_ID },
  about: { "@id": ORG_ID },
  inLanguage: "en-IN",
});

const breadcrumb = (path, name) => ({
  "@type": "BreadcrumbList",
  "@id": `${SITE}${path}#breadcrumb`,
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Home", item: `${SITE}/` },
    { "@type": "ListItem", position: 2, name, item: `${SITE}${path}` },
  ],
});

export const getJsonLd = (path) => {
  if (path === "/") return [organization, website, faqPage];
  if (path === "/about") {
    return [
      webPage("/about", "About KR Studio"),
      breadcrumb("/about", "About"),
      ...FOUNDERS.map((f) => ({ ...f, jobTitle: "Co-Founder", worksFor: { "@id": ORG_ID } })),
    ];
  }
  if (path === "/contact") return [webPage("/contact", "Contact KR Studio"), breadcrumb("/contact", "Contact")];
  return null;
};
